/**
 * Shared form fields for plan create/edit. The backend keeps the Stripe
 * product/price in sync on its own (create, and update when name/price
 * change); module toggles come from the modules catalogue.
 */

import {
  BooleanInput,
  CheckboxGroupInput,
  NumberInput,
  SelectInput,
  TextInput,
  required,
  useGetList,
  useTranslate,
} from 'react-admin';
import { Alert } from '@mui/material';

export const PlanFormFields = ({ isCreate }: { isCreate: boolean }) => {
  const translate = useTranslate();
  const { data: modules } = useGetList('modules', {
    pagination: { page: 1, perPage: 50 },
    sort: { field: 'module_id', order: 'ASC' },
  });

  return (
    <>
      <Alert severity="info" sx={{ mb: 2 }}>
        {translate('resources.plans.stripe_note')}
      </Alert>
      <TextInput source="name" validate={required()} />
      <TextInput source="description" validate={required()} multiline />
      <TextInput source="tagline" />
      <NumberInput source="price" validate={required()} min={0} step={0.01} />
      <SelectInput
        source="plan_type"
        validate={required()}
        choices={[
          { id: 'individual', name: translate('resources.plans.types.individual') },
          { id: 'company', name: translate('resources.plans.types.company') },
        ]}
      />
      <SelectInput
        source="duration"
        validate={required()}
        choices={[
          { id: 30, name: translate('resources.plans.durations.monthly') },
          { id: 365, name: translate('resources.plans.durations.yearly') },
        ]}
      />
      <BooleanInput
        source="is_qr_type_static"
        format={(value: any) => Boolean(value)}
        parse={(value: any) => (value ? 1 : 0)}
      />
      <NumberInput source="static_qr_limit" min={0} />
      <BooleanInput
        source="is_qr_type_dynamic"
        format={(value: any) => Boolean(value)}
        parse={(value: any) => (value ? 1 : 0)}
      />
      <NumberInput source="dynamic_qr_limit" min={0} />
      <NumberInput source="staff_member_limit" min={0} />
      <CheckboxGroupInput
        source="modules"
        choices={(modules ?? []).map((module: any) => ({
          id: module.module_id,
          name: module.module_name,
        }))}
      />
    </>
  );
};

export default PlanFormFields;
